import { GetAllJudgesRewardsResponse } from "./models/judgesRewardsTypes";

export const JudgesRewardsService = {
  getAllJudgesRewards: async () => {
    const response: GetAllJudgesRewardsResponse = {
      code: 200,
      description: "Success",
      hasError: false,
      data: {
        totalCount: 3,
        result: [
          {
            id: "1",
            arabicName: "محمد نايف",
            englishName: "Mohammed Naif",
            applicantName: "محمد عبدالله",
            orderNumber: "1",
            orderId: 1,
            researchCenter: "مركز البحوث",
            rewardAmount: 200,
            rewardApprovalDate: new Date().toISOString(),
            status: "Paid",
          },
          {
            id: "2",
            arabicName: "عبدالله محمد",
            englishName: "Abdullah Mohammed",
            applicantName: "عبدالله محمد",
            orderNumber: "2",
            orderId: 2,
            researchCenter: "مركز البحوث",
            rewardAmount: 100,
            rewardApprovalDate: new Date().toISOString(),
            status: "Pending",
          },
          {
            id: "3",
            arabicName: "عبدالله محمد",
            englishName: "Abdullah Mohammed",
            applicantName: "عبدالله محمد",
            orderNumber: "3",
            orderId: 3,
            researchCenter: "مركز البحوث",
            rewardAmount: 150,
            rewardApprovalDate: new Date().toISOString(),
            status: "NotPaid",
          },
        ],
      },
    };
    return response;
  },
  exportToExcel: async () => {
    return null;
  },
};
